import React from 'react';
import { Image } from 'react-native';
import type { PlayerPodcastEpisodeProps, PodcastEpisodesProps, PodcastProps } from '../types';
import { Icons } from '../Components';
import { SocialPodcastHelpers } from './api';
import moment from 'moment-mini';
import { useColors } from '../constants/useColors';
import { Button, Text, View } from '../Components/Themed';

type PodcastEpisodeCardProps = {
    podcast_episode:PodcastEpisodesProps
    player_podcast_episode?:PlayerPodcastEpisodeProps,
    podcast?:PodcastProps,
    width:number,
    onShare?:(pe:PodcastEpisodesProps) => void,
    onSelectEpisode:(pe:PodcastEpisodesProps) => void
}

const PodcastEpisodeCard = ({ width, podcast_episode, player_podcast_episode, onSelectEpisode, onShare }: PodcastEpisodeCardProps ) => {
    const Colors = useColors();

    return (
        <Button style={{  width, padding:0 }} onPress={() => onSelectEpisode(podcast_episode)}>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                <View transparent style={{ flex:1 }}>
                    <Text theme='h1'>{moment(podcast_episode.publish_date).format('MMM DD YYYY')}</Text>
                </View>
                {onShare?
                <Button transparent style={{ padding:5 }} onPress={() => onShare(podcast_episode)}>
                    <Icons.ShareIcon size={14} color={Colors.text.action} />
                </Button>
                :<></>}
            </View>
            <View transparent type='body'>
                <View transparent>
                    <Image
                        source={{ uri: SocialPodcastHelpers.getEpisodeImage(podcast_episode) }}
                        style={{ width: width, height: width * 0.666 }}
                    />
                    <View type='blur' style={{ position:'absolute', top:0, left:0, right:0, bottom:0, justifyContent:'center', alignItems:'center' }}>
                        <View transparent style={{ borderRadius:22, padding:10 }}>
                            <View float type='row' style={{ padding:10 }}>
                                <Icons.PlayIcon size={18} color={Colors.text.action} />
                                {player_podcast_episode ?
                                <Text size={14} color={Colors.text.action} weight='semibold' style={{ marginLeft:10 }}>Resume</Text>
                                :
                                <Text size={14} color={Colors.text.action} weight='semibold' style={{ marginLeft:10 }}>Play</Text>
                                }
                            </View>
                        </View>
                    </View>
                </View>
                <View transparent style={{ padding:10 }}>
                    <Text theme='h2'>{podcast_episode.title}</Text>
                </View>
            </View>
            
        </Button>
    )
}

export default PodcastEpisodeCard